import React from "react";
import TableRow from "./TableRow";

const TableBody = ({ orders }) => {
  const rows = orders.map((order, renavam, licensePlate) => (
    <TableRow key={order.id} {...order} {...renavam} {...licensePlate} />
  ));
  return <tbody>{rows}</tbody>;
};

export default TableBody;



// WEBPACK FOOTER //
// ./src/components/Pages/Orders/TableBody.js